/* Tenants Block ID */
const NC_BLOCK_ID = 1;
const KN_BLOCK_ID = 6;
const SN_BLOCK_ID = 7;

module.exports = {
  /* Custom date formats for moment library */
  momentDateFormats: {
    en: {
      longDateFormat: {
        l: 'D MMM YYYY',
        ll: 'ddd D MMM',
        LLL: 'dddd, Do MMMM',
        LLLL: 'Do MMM YYYY (dddd)',
      },
    },
    ja: {
      longDateFormat: {
        l: 'YYYY年M月D日',
        ll: 'M月D日(ddd)',
        LLL: 'M月D日(dddd)',
        LLLL: 'YYYY年M月D日(dddd)',
      },
    },
  },
  /* Tenants */
  tenants: {
    1: {
      name: 'nisekocentral',
      title: 'Niseko Central',
    },
    6: {
      name: 'kiniseko',
      title: 'Ki Niseko',
    },
    7: {
      name: 'skye',
      title: 'Skye Niseko',
    },
  },
  /* Tenants Block ID */
  NC_BLOCK_ID,
  KN_BLOCK_ID,
  SN_BLOCK_ID,
  /* Contact email address for tenants */
  contacts: {
    email: {
      kiniseko: 'concierge@kiniseko.com',
      nisekocentral: 'guestservices@nisekocentral.com',
      skye: 'concierge@skyeniseko.com',
    },
  },
  ownersContacts: {
    email: {
      kiniseko: 'owners@kiniseko.com',
      nisekocentral: 'owners@nisekocentral.com',
      skye: 'owners@skyeniseko.com',
    },
  },
  /* External links that are used in the system */
  links: {
    kiniseko: {
      taxDocuments: {
        japaneseTaxInfo: 'https://www.htmniseko.com/uploads/owners/Japanese-Tax-Information_Thomatsu.pdf',
        corporateTaxSchedule: 'https://www.htmniseko.com/uploads/owners/HTM-Corporate-Tax-Schedule.pdf',
        individualTaxSchedule: 'https://www.htmniseko.com/uploads/owners/HTM-Individual-Tax-Schedule.pdf',
        ownerTaxQuestionnaire: 'https://www.htmniseko.com/uploads/owners/HTM_Owner_Tax_Questionnaire.pdf',
      },
      downloadAllTaxDocuments: 'https://www.htmniseko.com/uploads/owners/All-Tax-Documents.pdf',
      chargeableWorkRate: 'https://www.htmniseko.com/uploads/owners/Rates-for-Chargeable-Work-Nov-2024.pdf',
      paymentRequirement: 'https://www.htmniseko.com/uploads/owners/KN-Requirements-for-Funds-Transfer.pdf',
    },
    nisekocentral: {
      taxDocuments: {
        japaneseTaxInfo: 'https://www.htmniseko.com/uploads/owners/Japanese-Tax-Information_Thomatsu.pdf',
        corporateTaxSchedule: 'https://www.htmniseko.com/uploads/owners/HTM-Corporate-Tax-Schedule.pdf',
        individualTaxSchedule: 'https://www.htmniseko.com/uploads/owners/HTM-Individual-Tax-Schedule.pdf',
        ownerTaxQuestionnaire: 'https://www.htmniseko.com/uploads/owners/HTM_Owner_Tax_Questionnaire.pdf',
      },
      downloadAllTaxDocuments: 'https://www.htmniseko.com/uploads/owners/All-Tax-Documents.pdf',
      chargeableWorkRate: 'https://www.htmniseko.com/uploads/owners/Rates-for-Chargeable-Work-Nov-2024.pdf',
      paymentRequirement: 'https://www.htmniseko.com/uploads/owners/NC-Requirements-for-Funds-Transfer.pdf',
    },
    skye: {
      taxDocuments: {
        japaneseTaxInfo: 'https://www.htmniseko.com/uploads/owners/Japanese-Tax-Information_Thomatsu.pdf',
        corporateTaxSchedule: 'https://www.htmniseko.com/uploads/owners/HTM-Corporate-Tax-Schedule.pdf',
        individualTaxSchedule: 'https://www.htmniseko.com/uploads/owners/HTM-Individual-Tax-Schedule.pdf',
        ownerTaxQuestionnaire: 'https://www.htmniseko.com/uploads/owners/HTM_Owner_Tax_Questionnaire.pdf',
      },
      downloadAllTaxDocuments: 'https://www.htmniseko.com/uploads/owners/All-Tax-Documents.pdf',
      chargeableWorkRate: 'https://www.htmniseko.com/uploads/owners/Rates-for-Chargeable-Work-Nov-2024.pdf',
      paymentRequirement: 'https://www.htmniseko.com/uploads/owners/SN-Requirements-for-Funds-Transfer.pdf',
    },
  },
  twoFANoteSymbol: '*',
  smsOptInNumber: '+1 833 271 0072',
  idleTimeout: 20 * 60 * 1000, // 20 minutes in milliseconds
  LogRocketDev: 'xjipyp/owner-portal-bkyg1',
  LogRocketProd: 'n5hc39/owner-portal',
};
